import React from 'react';
import { Link } from 'react-router-dom';
import {
  Header,
  Image,
} from 'semantic-ui-react';

const ModMenu = ({ user }) => {
  return (
    <React.Fragment>
      <Header as='h2' inverted>Mod Menu</Header>
      <p>
        The Mod Menu is the in-game menu provided by the mod. It will automatically display the very first time you start a run after installing
        the mod, however will need to be manually activated in subsequent runs. You can open or close the menu at any time using the <strong>F8</strong> key.
      </p>
      <Image src='/images/support_main_menu.png' />
      <br />
      <p>
        You can navigate the menu using your keyboard, mouse, or game controller.
      </p>
      <p>
        With the keyboard, you can navigate menu items using the arrow keys. You can press <strong>Enter</strong> to activate the current menu item, and you
        can press the <strong>Escape</strong> or <strong>Backspace</strong> key to return to the previous menu page.
      </p>
      <p>
        With the mouse, you can click on menu items directly to navigate through the menu. To go back, there is a <strong>X</strong> button in the top right corner
        of each menu page to be able to return to the previous menu page.
      </p>
      <p>
        With a game controller, you can navigate the menu with the directional buttons, and activate the current menu item with the Shoot Down button. To
        go back to the previous menu item, press the Shoot Right button.
      </p>
      <Header as='h3' inverted>Connect to Twitch</Header>
      <p>
        The Connect to Twitch screen is the first menu item off of the main menu. This is where you start the activation process for registering the mod with
        your Twitch account. Without this step, the mod will not be able to receive commands from chat.
      </p>
      <p>
        When you access this screen for the first time, you will have a button to start the activation process. You can click this button with your mouse,
        press Enter on your keyboard, or use the Shoot Down button on your game controller. Once you have activated the button, your default web browser
        will open the Twitching of Isaac website to link your Twitch account. Once you have logged in via Twitch, the mod will be activated.
      </p>
      <Image src='/images/support_register_mod.png' />
      <br />
      <p>
        When you have entered your registration token, you can either press <strong>Enter</strong>, or navigate to the <strong>Save</strong> button to attempt
        to register and save the registration token. If it was successful, it will take you back to the main screen and show an indicator that you are connected.
        If you enter an invalid code, it will show a message at the bottom of this screen and allow you to re-enter your key.
      </p>
      <Header as='h3' inverted>Announcements</Header>
      <p>
        The announcements screen will show you the latest updates from the last mod update. This will include updates related to the mod itself, or features
        that exist on the website. For your convenience, the main menu page will show you the date of the last announcement, so you can quickly tell if there
        are any new announcements.
      </p>
      <Image src='/images/support_announcements.png' />
      <br />
      <Header as='h3' inverted>Enable/Disable Commands</Header>
      <p>
        This menu screen will allow you to perform basic configuration of commands. If you are looking for advanced configuration options, such as managing
        ban lists, or cooldowns for commands, you will need to do so from this website.
      </p>
      <p>
        From the Enable/Disable Commands screen, you will see a multi-page listing of all the commands available to you. This includes both global built-in
        commands, as well as any Custom Commands that you have created.
      </p>
      <Image src='/images/support_commands.png' />
      <br />
      <p>
        Navigate through the listing using your arrow keys, mouse, or game pad controller, and you can toggle the state of a command by activating it. Activating
        a menu item will cycle its state from <strong>Enabled</strong> to <strong>Sub Only</strong> to <strong>Disabled</strong>. As you navigate through the
        commands, you will get a description of the command at the bottom of the screen.
      </p>
      <Header as='h3' inverted>About</Header>
      <p>
        The About screen will simply show information about the mod, as well as some debug information.
      </p>
      <Image src='/images/support_about.png' />
      <br />
      <p>
        The debug information includes listing which user is currently registered (if the mod has been registered), and the current connection status of the mod.
        Additionally, it will displayt if Repentance was detected -- it is possible for some mods to create a conflict and prevent proper detection of Repentance;
        if this is the case, it is recommended to disable other mods. If you happen to determine which mod might be causing a conflict, please let us know on the
        {' '}<Link to="https://discord.gg/FtJyJNcz2k">Twitching of Isaac Discord</Link>.
      </p>
    </React.Fragment>
  )
};

export default ModMenu;
